import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Sheet from 'components/utils/Sheet'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'

function CartPanelEmptyState() {
  const intl = useIntl()

  return (
    <Sheet padding="80 20" tabletPadding="80 24">
      <Group gap={20} direction="vertical" verticalAlign="center" horizontalAlign="center">
        <VerticalSpacer gap={12}>
          <Heading variant="heading2" align="center">
            {intl.formatMessage({
              id: 'qqWYfcjoWd3nlA5UbW46',
              defaultMessage: 'Your cart is empty',
              description: 'Heading shown when trip planner cart panel has no bookable items',
            })}
          </Heading>
          <BodyText variant="large" align="center">
            {intl.formatMessage({
              id: 'CRl8A6snC_FUgFwNifDJ',
              defaultMessage: 'Start planning your next escape by adding hotels, flights, experiences, and more to your cart.',
              description: 'Description text encouraging user to add items when trip planner cart panel is empty',
            })}
          </BodyText>
        </VerticalSpacer>
      </Group>
    </Sheet>
  )
}

export default CartPanelEmptyState
